module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av98-aa8863910e6e47e9588634342274f363.jpg";